<template>
  <div
    v-if="valueWithDifference"
    :class="classes">
    <div class="is-marginless is-size-3 has-text-weight-medium">
      <stat-value
        classes="is-size-3 has-text-weight-medium"
        :value="value"
        :euro="euro"
        :percentage="percentage"></stat-value>
      <sup class="is-size-5">
        <i
          class="fal"
          :class="[differenceValue > 0 ? 'fa-arrow-up is-rotate-45 has-text-success' : differenceValue < 0 ? 'fa-arrow-right is-rotate-45 has-text-danger' : 'fa-arrow-right has-text-dark transparent']"></i>
      </sup>
    </div>
    <div
      class="is-marginless is-size-7"
      :class="differenceValue > 0 ? 'has-text-success' : differenceValue < 0 ? 'has-text-danger' : 'has-text-dark transparent'">
      {{ !isNaN(differenceValue) && isFinite(differenceValue) ? differenceValue.toFixed(2) : 0 }} %
    </div>
  </div>
  <div
    v-else-if="difference && isTag"
    :class="classes">
    <div
      class="is-radius has-text-white is-padding-xxsmall"
      :class="value > 0 ? 'has-background-success' : value < 0 ? 'has-background-danger' : 'has-background-dark'">
      <span class="icon">
        <i
          class="far"
          :class="value > 0 ? 'fa-arrow-up' : value < 0 ? 'fa-arrow-down' : 'fa-arrow-right'"></i>
      </span>
      <stat-value
        :value="value"
        :euro="euro"
        :percentage="percentage"
        :transparent="false"></stat-value>
    </div>
  </div>
  <span
    v-else-if="difference"
    :class="classes">
    <span :class="displayValue > 0 ? 'has-text-success' : displayValue < 0 ? 'has-text-danger' : 'has-text-light'">
      <span class="icon">
        <i
          class="far"
          :class="displayValue > 0 ? 'fa-arrow-up' : displayValue < 0 ? 'fa-arrow-down' : 'fa-arrow-left'"></i>
      </span>
      <stat-value
        :value="displayValue"
        :euro="euro"
        :percentage="percentage"></stat-value>
    </span>
  </span>
  <span
    v-else
    :class="[{'transparent': value <= 0 && transparent, 'is-size-6': !total && !classes}, classes]">
    <span v-if="euro">
      {{ displayValue | prettyPrice }} €
    </span>
    <span v-else-if="percentage">
      {{ displayValue.toFixed(2) }} %
    </span>
    <span v-else>
      {{ displayValue }}
    </span>
  </span>
</template>

<script>
import { isNaN } from 'lodash'
export default {
  name: 'StatValue',
  components: {
    StatValue: () => import('./StatValue')
  },
  props: {
    value: {
      type: null,
      required: true
    },
    euro: {
      type: Boolean,
      default: false
    },
    percentage: {
      type: Boolean,
      default: false
    },
    total: {
      type: Boolean,
      default: false
    },
    difference: {
      type: Boolean,
      default: false
    },
    valueWithDifference: {
      type: Boolean,
      default: false
    },
    differenceValue: null,
    isTag: {
      type: Boolean,
      default: false
    },
    classes: String,
    transparent: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isFinite
    }
  },
  computed: {
    displayValue () {
      return (!this.value || isNaN(this.value) || !isFinite(this.value)) ? 0 : Number(this.value)
    }
  }
}
</script>

<style scoped>
.transparent {
  opacity: 0.25;
}
</style>
